import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as SharedActions from './shared.actions';
import {catchError, ignoreElements, map, switchMap, tap} from "rxjs/operators";
import {Injectable} from "@angular/core";
import {DocumentScanningService} from "../services/document-scanning.service";
import {of} from "rxjs";
import {ShortUrlService} from "../services/short-url.service";
import {DocumentScanningSignalRService} from "../services/document-scanning-signal-r.service";
import {DocumentScanningStatus} from "../models/document-scanning.models";
import {Guid} from "guid-typescript";

@Injectable()
export class SharedEffects {

  constructor(
    private actions$: Actions,
    private documentScanningService: DocumentScanningService,
    private shortUrlService: ShortUrlService,
    private signalR: DocumentScanningSignalRService
  ) {
  }

  scanDocument$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SharedActions.scanDocumentUsingWebService),
      tap(async () => {
        await this.signalR.updateScanningProcess(DocumentScanningStatus.InProgress)
      }),
      switchMap((action) =>
        this.documentScanningService
          .scanDocument(action.formTemplateCode, action.docScanWebComponentResult, action.isBackoffice)
          .pipe(
            ignoreElements(),
            catchError(errors => {
              return of(SharedActions.scanDocumentUsingWebServiceError({errors: errors}))
            })
          )
      )
    )
  );

  getShortUrl$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SharedActions.getShortUrl),
      switchMap((action) =>
        this.shortUrlService.getShortUrl(action.longUrl)
          .pipe(
            map((result) => {
                return SharedActions.getShortUrlSuccess({shortUrl: result.shortUrl});
              }
            ),
            catchError((error) => {
              return of(SharedActions.getShortUrlFailure({error}));
            })
          )
      )
    )
  );

  createUid$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SharedActions.createUid),
      switchMap(() => {
        const uid = Guid.create().toString();
        sessionStorage.setItem('uid', uid);
        return of(SharedActions.createUidSuccess({ uid }));
      })
    );
  });

}
